import DownloadUserPage from "./DownloadUserPage";

const module = {
  routeProps: {
    path: "DownloadUser",
    component: DownloadUserPage,
  },
  name: "Download User Page",
  label: "Download User Page ",
  title: "Download User Page",
  showOnMenu: true,
};

export default module;
